module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form-builder-editor-field', _vm._g({
    attrs: {
      "item": _vm.item,
      "show-hide-in-form": true,
      "show-hide-in-preview": true,
      "show-hide-in-reports": true,
      "show-required": true,
      "show-share-with-participant": true,
      "show-is-shared": true
    }
  }, _vm.$listeners), [_c('editor-options-list', {
    attrs: {
      "values": _vm.item.values,
      "id": _vm.item.name,
      "show-templates": true
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64aa00e8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/editors/FormBuilderEditorCheckboxGroup.vue
// module id = 1673
// module chunks = 1